module.exports = __webpack_public_path__ + "img/1535905748.943927bf.jpg";